import { FunctionalComponent, h } from 'preact';

import { AutocompleteSectionInterface } from 'common/module/autocomplete/section.interface';
import { AutocompleteSectionTemplate } from 'common/module/autocomplete/section/template';
import { AutocompleteTemplatePropsInterface } from 'common/module/autocomplete/template-props.interface';
import { preactLifecycleComponent } from 'common/module/preact/lifecycle-component';

const Markup: FunctionalComponent<AutocompleteTemplatePropsInterface> = (props) => (
  <div className='autocomplete building-review-form__autocomplete'>
    <div className='autocomplete__input-wrapper'>
      <input
        ref={(el) => props.onInputRendered && props.onInputRendered(el as HTMLInputElement)}
        className='autocomplete__input building-review-form__autocomplete-input'
        onKeyUp={props.onKeyUpInput}
        onKeyDown={props.onKeyDownInput}
        onClick={props.onClickInput}
        placeholder={props.placeholder || ''}
      />
    </div>
    <div
      className='autocomplete__dropdown building-review-form__autocomplete-dropdown'
      ref={props.onDropdownRendered}
      style={{ display: props.isOpened && !!props.autocompleteResults.length ? 'block' : 'none' }}
    >
      {props.autocompleteResults.map(
        (result: AutocompleteSectionInterface, index) =>
          !!result.suggestions.length && (
            <AutocompleteSectionTemplate
              isFocused={props.focusedSection === index}
              focusedSuggestion={props.focusedSuggestion}
              suggestionSection={result}
              searchString={props.searchString}
              onFocusResultItem={props.onFocusResultItem}
              onSelectResultItem={props.onSelectResultItem}
            />
          )
      )}
    </div>
  </div>
);

export const BuildingReviewAutocompleteTemplate = preactLifecycleComponent(Markup);
